import { createContext, useState } from "react";

export const ConopsContext = createContext(null);

export const ConopsContextProvider = ({ children }) => {
    const [selectedOpenSearchValue, setSelectedOpenSearchValue] = useState("");
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCounty, setSelectedCounty] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [messages, setMessages] = useState([]);
    const [moveToBottom, setMoveToBottom] = useState(false);
    const [showWelcome, setShowWelcome] = useState(true);
    const [fetchSessionsFn, setFetchSessionsFn] = useState(null);
    const [registerId, setRegisterId] = useState(null)
    const [markerRegistryId, setMarkerRegistryId] = useState(null)
    const [facilityTableObject, setFacilityTableObject] = useState([])
    const [selectedFacilityType, setSelectedFacilityType] = useState(null);
    const [countyObject, setCountyObject] = useState(null);
    const [refineSearchProjectObject, setRefineSearchProjectObject] = useState(null)

    return (
        <ConopsContext.Provider
            value={{
                selectedOpenSearchValue, setSelectedOpenSearchValue,
                selectedState, setSelectedState,
                selectedCounty, setSelectedCounty,
                selectedCity, setSelectedCity,
                selectedFacility, setSelectedFacility,
                registerId, setRegisterId,
                markerRegistryId, setMarkerRegistryId,
                messages, setMessages,
                moveToBottom, setMoveToBottom,
                showWelcome, setShowWelcome,
                fetchSessionsFn, setFetchSessionsFn,
                facilityTableObject, setFacilityTableObject,
                selectedFacilityType, setSelectedFacilityType,
                countyObject, setCountyObject,
                refineSearchProjectObject, setRefineSearchProjectObject
            }}

        >
            {children}
        </ConopsContext.Provider>
    );
};

